import React from "react";

const gauri_kale = () => {
  return (
    <div>
      <h1>Gauri Kale</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        Candidates from the Computer Engineering branch with a CGPA of 7.0 or
        above were eligible to appear for the Aptitude Round. Based on their
        performance in this round, students were shortlisted for the interview.
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The Aptitude Test was for 90 minutes. It had MCQs from OOPS, DBMS,
        Computer Networks, and Operating Systems. There were also some code
        snippets where we had to predict the output, and two coding questions of
        medium to hard level, both based on graphs.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        After the Aptitude Round, 22 students were shortlisted. Around 12–13
        students appeared for the ProFit Round, and 9 students were then
        selected for the HR Round. Finally, 7 students received the final offer.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        We appeared for the Aptitude Test, and the results were announced the
        same night. The interviews were scheduled for the next morning at 9:30
        AM, so there was very little time to prepare. I could only manage to
        revise my projects. Between the interview rounds, there was a waiting
        time of about 30-35 minutes, which I used to quickly go over the basic
        concepts of DBMS, OOPs, and other subjects.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief?
        </strong>
        <br />
        There were 3 interview rounds :<br />
        1. <strong>Technical Round (35 - 45 mins)</strong> :{" "}
      </p>

      <ul>
        <li>
          In the Technical Round, they began by asking me questions about Java.
          Then, they asked some basic DBMS questions and asked me to write
          simple queries.{" "}
        </li>
        <li>
          After that, the focus shifted to my projects. I had to explain the
          tech stacks I used, the algorithms implemented, and what improvements
          I could make. In my DSA project, I had used a Trie data structure, so
          they asked me to explain it and write some basic functions related to
          it.{" "}
        </li>
        <li>
          Finally, they asked me to draw an ERD after giving the entities and
          their relationships. Towards the end, they also asked about my hobbies
          and favorite subjects, and then the round was over.
        </li>
      </ul>

      <p>
        2. <strong>Professional Fitness Round (40 mins)</strong> :{" "}
      </p>

      <ul>
        <li>
          In the ProFit Round, they asked me basic Java questions, including
          some built-in functions and classes.{" "}
        </li>
        <li>
          Then, they asked me to explain the graph question from the Aptitude
          Test. Most of the round focused on my projects and web development
          work, where I had to write both frontend and backend code.{" "}
        </li>
        <li>
          At the end, they also asked some general knowledge and scenario-based
          questions.
        </li>
      </ul>

      <p>
        3. <strong>HR Round (10 - 15 mins)</strong> :{" "}
      </p>

      <ul>
        <li>
          The round started with my introduction and then they asked about my
          day, some scenario based questions, my experience at COEP, how I deal
          with challenges, and my future plans etc.
        </li>
      </ul>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        The interviewer checked how much you know about each subject, your
        thinking ability and problem solving skills.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
      </p>

      <ul>
        <li>
          <strong>For DSA :</strong> Love Babbar Playlist and Abdul Bari course.{" "}
        </li>
        <li>
          <strong>For Coding :</strong> Striver sheet, Leetcode and
          GeeksforGeeks{" "}
        </li>
        <li>
          <strong>For CS Core :</strong> For DBMS again Love Babbar playlist,
          For OOPS and Java I used class notes.{" "}
        </li>
        <li>
          <strong>For Web Dev</strong> : code with harry and Love Babbar
          playlist, W3school.
        </li>
      </ul>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Focus on understanding the problem first and break it into small steps.
        <br />
        First try it by yourself, don’t directly jump to the Optimal solution.
        <br />
        Practice regularly. And try different approaches to solve the problem.
        Learn to debug your code.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Focus on strengthening your basics in core subjects like DSA, DBMS, and
        OOPs, as the company gives a lot of importance to them. Revise your
        projects well because many questions are asked around them.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        Build a strong foundation in basics like DSA, DBMS, and OOPs.
        <br />
        Practice coding regularly. Be confident while explaining.
        <br />
        You don’t need fancy projects to crack the interview; just know your
        project well from all aspects.
        <br />
        Finally, while answering coding questions to the interviewer, make sure
        to think out loud !!
      </p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Email :</strong>{" "}
        <a href="mailto:kalegs23.comp@coeptech.ac.in">
          kalegs23.comp@coeptech.ac.in
        </a>
      </p>
    </div>
  );
};

export default gauri_kale;
